import { reatomAsync, withAbort } from "@reatom/async";
import { ExportJobIdDto } from "definitions/exporter";
import { API } from "src/api";
import { toastHandler, truncateStart } from "src/util";

export const deleteRepeatableJobRequest = reatomAsync(
  async (ctx, data: ExportJobIdDto) => {
    API.exporterQueueApi
      .exportControllerDeleteExportRepeatableJob(data, {
        signal: ctx.controller.signal,
      })
      .then((response) => {
        if (response.data) {
          toastHandler.success({
            name: "deleteRepeatableJob",
            title: "Удаление повторяющейся задачи",
            content: `Задача ${truncateStart(data.id)} удалена`,
          });
        }
      });
  },
  {
    name: "deleteRepeatableJobRequest",
  },
).pipe(withAbort());
